import { createPubSubHooks } from "@/shared/utils/pubSub";

export const [useOpenSearchAssist, useOnOpenSearchAssist] = createPubSubHooks();
